import { render, staticRenderFns } from "./adjust.vue?vue&type=template&id=6adc243d&scoped=true"
import script from "./adjust.vue?vue&type=script&lang=js"
export * from "./adjust.vue?vue&type=script&lang=js"
import style0 from "./adjust.vue?vue&type=style&index=0&id=6adc243d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc243d",
  null
  
)

export default component.exports